import { useState, useEffect } from 'react';
import { useApi } from '../../../../../libs/data-access/src/api/useApi';
import { TPaginationStatus } from '../../../../../types';
import { PAGINATION_ITEM_LIMIT } from '../../../../../libs/data-access/constant';
import { showToast } from '../../../../../utils/utility';
import { IApplyOn } from '../../../../../libs/data-access/types';
export  const useApplyOn = () => {
    
    const {
        postData,
        patchData,
        putData
    } = useApi();

    const [isLoading, setIsLoading] = useState(false);
    const [isSwitchLoadingIndex, setIsSwitchLoadingIndex] = useState<number>();
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isOpenModalValue, setIsOpenModalValue] = useState<"New" | "Edit" | "Delete" | undefined >(undefined);
    const [searchValue, setSearchValue] = useState("");
    const [applyOnList, setApplyOnList] = useState<IApplyOn[]>([]);
    const [selectedApplyOn, setSelectedApplyOn] = useState<IApplyOn | undefined>(undefined);
    const [newApplyOn, setNewApplyOn] = useState<IApplyOn>({name:""});

      useEffect(() => {
        if(searchValue?.length > 2 || searchValue === ""){
        getApplyOnList("INITIAL_PAGE");
    }
    }, [searchValue])



    // API FUNCTION
    const getApplyOnList = async (paginationAction: TPaginationStatus, id?: number) => {
        setIsLoading(true);
        const response = await postData(`charge-apply-on-type/get-all`,
            {
                paginationFilterRequest: {
                    paginationAction: paginationAction,
                    maxLimit: PAGINATION_ITEM_LIMIT,
                    id: id ?? null,
                    sortingOrder: "ASC"
                },
                search: searchValue ?? "",
            })
        setIsLoading(false);

        if (response.isSuccess) {
            setApplyOnList(response.data.data)
        } else {
            setApplyOnList([])
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };
    }

    const submitNewApplyOn = async () => {
        setIsBtnLoading(true);
        const response = await postData(`charge-apply-on-type/create`, newApplyOn);
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Apply on type added successfully",
            })
            getApplyOnList("INITIAL_PAGE");
            setIsOpenModalValue(undefined);
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsBtnLoading(false);
    }

    const UpdateStatus = async (id: number, status: boolean, index: number) => {
        setIsSwitchLoadingIndex(index);
        const response = await patchData(`charge-apply-on-type/${status ? "active-all" :  "inActive-all" }?ids=${[id]}`,{});
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Apply on type status updated successfully",
            })
            getApplyOnList("INITIAL_PAGE");
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsSwitchLoadingIndex(undefined);
    }

    const UpdateApplyOn = async (id: number, name: string) => {
        setIsBtnLoading(true)
        const response = await putData(`charge-apply-on-type/update`, {id: id, name: name});
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Apply on type updated successfully",
            })
            getApplyOnList("INITIAL_PAGE");
            setSelectedApplyOn(undefined);
            setIsOpenModalValue(undefined);
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsBtnLoading(false);
    }

    const deleteApplyOn = async (id: number) => {
       const isConfirm = window.confirm("Are you sure you want to delete this Apply on type?");
        if(!isConfirm) return;
        else{
            setIsBtnLoading(true);
            showToast({
                type:"success",
                title:"Ready to delete",
                message:"Add api to delete apply on"
            })

        }
        // setIsBtnLoading(true);
        // const response = await putData(`charge-apply-on-type/delete`, {id: id});
        // if (response.isSuccess) {
        //     showToast({
        //         type: "success",
        //         message: "Apply on type deleted successfully",
        //     })
        //     getApplyOnList("INITIAL_PAGE");
        //     setSelectedApplyOn(undefined);
        // } else {
        //     showToast({
        //         type: "error",
        //         message: response.message ?? "Something went wrong",
        //     })
        // };
        // setIsBtnLoading(false);
    }

    return {
        isLoading,
        isSwitchLoadingIndex,
        isBtnLoading,
        isOpenModalValue,
        setIsOpenModalValue,
        applyOnList,
        searchValue,
        setSearchValue,
        selectedApplyOn,
        setSelectedApplyOn,
        newApplyOn,
        setNewApplyOn,
        submitNewApplyOn,
        UpdateStatus,
        UpdateApplyOn,
        deleteApplyOn,
       
    }
}